module.exports = __webpack_public_path__ + "department_dark.5ca80250e13dc357a1f6.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/department_dark.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/department_dark.svg
// module chunks = styles